// extracted by mini-css-extract-plugin
export default {"overflowFade":"_3J74XsK"};